import { render, staticRenderFns } from "./info-card.vue?vue&type=template&id=3c8686a4&scoped=true&"
import script from "./info-card.vue?vue&type=script&lang=ts&"
export * from "./info-card.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c8686a4",
  null
  
)

export default component.exports